import { render, staticRenderFns } from "./payment-tip-dialog.vue?vue&type=template&id=790692a5&scoped=true"
import script from "./payment-tip-dialog.vue?vue&type=script&lang=js"
export * from "./payment-tip-dialog.vue?vue&type=script&lang=js"
import style0 from "./payment-tip-dialog.vue?vue&type=style&index=0&id=790692a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790692a5",
  null
  
)

export default component.exports